import { render, staticRenderFns } from "./UserTabUp.vue?vue&type=template&id=cc0e84e4&scoped=true"
import script from "./UserTabUp.vue?vue&type=script&lang=js"
export * from "./UserTabUp.vue?vue&type=script&lang=js"
import style0 from "./UserTabUp.vue?vue&type=style&index=0&id=cc0e84e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0e84e4",
  null
  
)

export default component.exports